import { GetBranchAliases } from './settings';

export const resolveBranchName = (branchName?: string) => {
  if (!branchName) return undefined;
  const aliases = GetBranchAliases();
  const match = aliases?.find((x) => x.original_name.localeCompare(branchName) === 0)?.name;
  return match || branchName;
};
